export default {
  created () {
    this.loadFilterFromStorage()
  },
  methods: {
    getStorageKey () {
      const view = this.$router.currentRoute.name
      return `${view}-filter`
    },
    loadFilterFromStorage () {
      try {
        const data = JSON.parse(sessionStorage.getItem(this.getStorageKey()))
        Object.keys(data).forEach(name => {
          const values = data[name]
          if (Array.isArray(values)) {
            values.forEach(value => {
              this.addFilter(name, value)
            })
          } else {
            // Toggle filter
            this.filter[name].isActive = values
          }
        })
      } catch (e) {}
    },
    saveFilterToStorage () {
      const data = Object.keys(this.filter).reduce((data, name) => {
        const { values, isActive } = this.filter[name]
        if (values && values.length) {
          data[name] = values
        } else if (isActive !== 'undefined') {
          data[name] = isActive
        }
        return data
      }, {})

      try {
        sessionStorage.setItem(this.getStorageKey(), JSON.stringify(data))
      } catch (e) {}
    },
    addFilter (type, filter) {
      if (filter && !this.filter[type].values.includes(filter)) {
        this.filter[type].values.push(filter)
        this.saveFilterToStorage()
      }
    },
    toggleFilter (type) {
      this.filter[type].isActive = !this.filter[type].isActive
      this.saveFilterToStorage()
    },
    filterCollection (data) {
      const filters = Object.values(this.filter)
        .filter(
          ({ value, values, isActive }) =>
            isActive || !!value || (values && !!values.length)
        )
        .map(filter => filter.filter.bind(filter))
      return data.filter(item =>
        filters.every(filter => {
          return filter(item)
        })
      )
    }
  },
  computed: {
    activeFilters () {
      return Object.keys(this.filter)
        .filter(key => Array.isArray(this.filter[key].values))
        .reduce((filters, group) => {
          return [
            ...filters,
            ...this.filter[group].values.map(filter => ({
              label: `${this.filter[group].label}: ${filter.label}`,
              remove: () => {
                this.filter[group].values = this.filter[group].values.filter(
                  value => value !== filter
                )
                this.saveFilterToStorage()
              }
            }))
          ]
        }, [])
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/filter-listing.js